import React from "react";
import "./HomeBeautyVibeSection.css";

function HomeBeautyVibeSection() {
  const beautyVibePosts = [
    { id: 1, image: "/images/beautyvibe1.webp" },
    { id: 2, image: "/images/beautyvibe2.webp" },
    { id: 3, image: "/images/beautyvibe3.webp" },
    { id: 4, image: "/images/beautyvibe4.webp" },
    { id: 5, image: "/images/beautyvibe5.webp" },
    { id: 6, image: "/images/beautyvibe6.webp" },
    { id: 7, image: "/images/beautyvibe7.webp" },
  ];

  const handleFollowClick = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    window.location.href = "/about";
  };

  return (
    <section className="beautyvibe-section">
      <h2 className="beautyvibe-title">#Beauty Vibes</h2>

      <a
        href="/about"
        className="beautyvibe-follow"
        onClick={handleFollowClick}
      >
        FOLLOW US
      </a>

      <div className="beautyvibe-scroll">
        <div className="beautyvibe-track">
          {beautyVibePosts.map((post) => (
            <div className="beautyvibe-post" key={`original-${post.id}`}>
              <img src={post.image} alt={`Beauty Vibe ${post.id}`} />
            </div>
          ))}

          {beautyVibePosts.map((post) => (
            <div className="beautyvibe-post" key={`duplicate-${post.id}`}>
              <img src={post.image} alt={`Beauty Vibe ${post.id}`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HomeBeautyVibeSection;